import React, { useState } from "react";
import styled from "styled-components";

import { Accordion } from "react-bootstrap";

import circle from "../../../assets/images/circle.png";
import MOB_BG from "../../../assets/images/mobile/CEL.png";
import POSTER from "../../../assets/videos/mode-of-use/poster.jpg";

import REGISTRO_DE_DATOS from "../../../assets/videos/mode-of-use/registro_de_datos.mp4";
import ADMINISTRAR from "../../../assets/videos/mode-of-use/adminstrar_polizas.mp4";
import ANADIR from "../../../assets/videos/mode-of-use/anadir_una_poliza.mp4";
import COMPARTIR from "../../../assets/videos/mode-of-use/compartir_polizas.mp4";
import COTIZAR from "../../../assets/videos/mode-of-use/cotizar_polizas.mp4";
import REPORTAR_SINIESTRO from "../../../assets/videos/mode-of-use/reportar_siniestro_de_auto.mp4";

const SectionWrapper = styled.section`
	padding: 6%;
	min-height: 830px;
	position: relative;

	.main-title {
		color: #5268c2;
		font-size: 4.5em;
		font-weight: 700;
		text-align: left;
		margin-bottom: 0px !important;
		@media only screen and (max-width: 700px) {
			font-size: 3em;
		}
	}
	.main-subtitle {
		font-size: 4em !important;
		color: #5268c2;
		margin-bottom: 20px !important;
		@media only screen and (max-width: 700px) {
			font-size: 2em !important;
		}
	}
	.accordion {
		position: relative;
		margin-bottom: 30px;
		margin-left: 60px;
		button {
			color: #bdc5e2;
			font-size: 22px;
			font-weight: 800;
			background: transparent;
			border: none;
			padding: 0;
		}

		.subtitle {
			text-align: left;
			margin: 0;
			padding: 0;
			font-size: 20px;
			color: ##444444;
			font-weight: 500;
		}

		.desc {
			color: #858585;
			font-size: 18px;
			max-width: 800px;
		}

		.mark {
			position: absolute;
			left: -55px;
			height: 12px;
			top: 12px;
			width: 43px;
			background: #3cdbc0;
		}
	}
	.active {
		button {
			color: #5268c2;
		}
	}
	.mobile-container {
		position: relative;
		width: 400px;
		height: 800px;
		filter: drop-shadow(0 0 35px #5268c2);
		&:after {
			content: "";
			display: block;
			background: url("${MOB_BG}") no-repeat transparent;
			width: 100%;
			height: inherit;
			background-size: 400px;
			left: 0px;
			top: 0px;
			position: absolute;
			z-index: 1;
		}
		video {
			background: black;
			position: absolute;
			cursor: pointer;
			border-radius: 20px;
			top: 38px;
			left: 42px;
			z-index: 0;
			height: 685px;
			width: 315px;
		}
	}
	.circle-img1 {
		position: absolute;
		width: 250px;
		top: -60px;
		left: 0%;
		z-index: -3;
	}
	.circle-img2 {
		position: absolute;
		width: 350px;
		bottom: -60px;
		right: 0%;
		z-index: -3;
	}
`;

const ModeOfUse_Tabs = [
	{
		id: "registro_de_datos",
		title: "Registro de datos",
		desc: "Te llevamos de una manera simple a como registrar los datos de un usuario en nuestra app a través de Facebook, Gmail o tu cuenta de correo.",
	},
	{
		id: "administrar_polizas",
		title: "Administrar pólizas",
		desc: "Te sorprenderás como te enseñamos a administrar todo tu portafolio de seguros (pólizas) en nuestra app.",
	},
	{
		id: "anadir_una_poliza",
		title: "Añadir una póliza",
		uri: true,
		uri_text: "Bajatuseguro.com!",
		desc: "No dejes fuera de nuestro sistema ninguna de tus pólizas aun no contratadas con nosotros. ¡Vive la experiencia",
	},
	{
		id: "compartir_polizas",
		title: "Compartir pólizas",
		desc: "Vive tranquilo, sin la preocupación de tener que estar sacando copia a tu póliza, hemos pensado en todo y nuestro sistema te permite compartir tus pólizas con tus seres queridos o equipo de trabajo.",
	},
	{
		id: "reportar_siniestro_de_auto",
		title: "Reportar siniestro de auto",
		desc: "No estás solo y sabemos que tu peor estrés es reportar un siniestro, nosotros lo hemos hecho fácil y además estamos contigo en todo el proceso.",
	},
];

const VideoTabs = () => {
	const [selected, setSelected] = useState("registro_de_datos");

	return (
		<SectionWrapper>
			<div className='row'>
				<div className='col-sm-12 col-md-5 col-lg-7'>
					<p className='main-title'>Conoce más</p>
					<p className='main-subtitle'>sobre como cotizar</p>
					{ModeOfUse_Tabs.map((mode) => (
						<Accordion
							key={mode.id}
							className={selected == mode.id ? "active" : ""}
							activeKey={selected}>
							<>
								{selected === mode.id && <span className={"mark"} />}
								<Accordion.Toggle
									eventKey={mode.id}
									onClick={() => setSelected(mode.id)}>
									{mode.title}
								</Accordion.Toggle>
								<Accordion.Collapse
									eventKey={mode.id}
									className={selected == mode.id ? "show" : ""}>
									<p className='desc'>
										{mode.desc}{" "}
										{mode.link && <a href={mode.uri}>{mode.uri_text}</a>}
									</p>
								</Accordion.Collapse>
							</>
						</Accordion>
					))}
				</div>
				<div
					className='col-sm-12 col-md-5 col-lg-5'
					style={{ position: "relative" }}>
					<img src={circle} alt='circle1' className='circle-img1' />
					<div className='mobile-container'>
						{Object.keys(VID).map(
							(a) =>
								a === selected && (
									<video poster={POSTER} autoPlay>
										<source src={VID[selected]} type='video/mp4' />
									</video>
								),
						)}
					</div>
					<img src={circle} alt='circle2' className='circle-img2' />
				</div>
			</div>
		</SectionWrapper>
	);
};

const VID = {
	registro_de_datos: REGISTRO_DE_DATOS,
	administrar_polizas: ADMINISTRAR,
	anadir_una_poliza: ANADIR,
	compartir_polizas: COMPARTIR,
	cotizar_polizas: COTIZAR,
	reportar_siniestro_de_auto: REPORTAR_SINIESTRO,
};
export default VideoTabs;
